<template>
<form>
    <div class="row">
        <div class="col-lg-9">
            <div class="row">
                <div class="col-lg-12">
                    <h4 class="card-title font-weight-bold">{{ $t('proposals_ev.section_title__admissibility_eligibility_check') }}</h4>
                </div>
            </div>
            <application-info></application-info>
            <p class="font-weight-bold mt-3">Comments:</p>
            <div class="col-6" style="overflow: hidden">
                <comment-box
                    class="form-group"
                    v-model="EvaluationForm.model.esms_comments"
                    :is-editable="EvaluationForm.isEditable"
                    :comments="EvaluationForm.model.esms_comments">
                </comment-box>
            </div>
            <div class="mt-3">
                <p class="font-weight-bold mb-3">{{ $t('proposals_ev.upload__admissibility_and_eligibility_report') }}</p>
                <upload-file
                    v-model="EvaluationForm.files.esms.esms_clearance"
                    :is-evaluation="true"
                    :file-data="EvaluationForm.files.esms.esms_clearance"
                    :is-editable="EvaluationForm.isEditable"
                    section="esms.esms_clearance"
                    >
                </upload-file>
            </div>
        </div>
        <div class="col-lg-3">
            <info-right></info-right>
        </div>
    </div>
</form>
</template>
<script>
import {
    EvaluationForm
} from "@/services";
import {CommentBox} from 'src/components';
import InfoRight from './InfoRight';
import ApplicationInfo from '../ApplicationInfo';

export default {
    components: {
        InfoRight,
        CommentBox,
        ApplicationInfo
    },
    data() {
        return {
            EvaluationForm
        }
    },
    beforeCreate() {
        if (!EvaluationForm.files.esms) {
            EvaluationForm.files.esms = {};
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit('on-validated', res, this.model);
                return res;
            });
        }
    }
}
</script>
